import {
  BadgePercent,
  Banknote,
  FlaskConical,
  Hourglass,
  Landmark,
  ListChecks,
  type LucideIcon,
  PiggyBank,
  ReceiptText,
  Share2,
  Undo2,
  Users,
} from 'lucide-react';

/** URL keys of the reports (`?tab=`). Kept from the first version so saved links still work. */
export const REPORT_TABS = [
  'lines',
  'receipts',
  'discounts',
  'cancelled',
  'methods',
  'entries',
  'outstanding',
  'deposits',
  'lab',
  'staff',
  'share',
] as const;
export type ReportTab = (typeof REPORT_TABS)[number];

export type ReportGroup = 'sales' | 'money' | 'team';

export type ReportEntry = { key: ReportTab; group: ReportGroup; icon: LucideIcon };

/** The left menu, top to bottom: what was sold · where the money is · who earned it. */
export const REPORTS: readonly ReportEntry[] = [
  { key: 'lines', group: 'sales', icon: ListChecks },
  { key: 'receipts', group: 'sales', icon: ReceiptText },
  { key: 'discounts', group: 'sales', icon: BadgePercent },
  { key: 'cancelled', group: 'sales', icon: Undo2 },
  { key: 'methods', group: 'money', icon: Landmark },
  { key: 'entries', group: 'money', icon: Banknote },
  { key: 'outstanding', group: 'money', icon: Hourglass },
  { key: 'deposits', group: 'money', icon: PiggyBank },
  { key: 'lab', group: 'money', icon: FlaskConical },
  { key: 'staff', group: 'team', icon: Users },
  { key: 'share', group: 'team', icon: Share2 },
];

export const REPORT_GROUPS: readonly ReportGroup[] = ['sales', 'money', 'team'];

/** What each report can be filtered by (the toolbar and the filter sheet show only these). */
export type FilterShow = {
  range?: boolean;
  items?: boolean;
  categories?: boolean;
  status?: boolean;
  staff?: boolean;
  /** one way the money came in (cash, transfer …) */
  method?: boolean;
  search?: boolean;
};
